import * as React from 'react';
import { Button, Card } from 'antd';
import { AppState, AuthResult } from '../../store';
import { InjectedFormProps, Field, reduxForm, SubmissionError } from 'redux-form';
import { Icon } from 'antd';
import { TextField } from 'redux-form-antd';
import { required } from '../../reduxFormAntd';
import { connect, Dispatch } from 'react-redux';
import { passwordsMatch } from 'src/reduxFormAntd/validations';
import { RouteComponentProps } from 'react-router';
import { Observable } from 'rxjs';
import * as firebase from 'firebase/app';
import { push } from 'react-router-redux';
import { actions as toast } from 'src/toast';

const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 },
    },
};

const mapStateToProps = (appState: AppState, props: Props) => {
    const { match: { params: { id, merchantId } } } = props;
    
    // const initialData = getInitialFormData(appState, props);
    return {
        id,
        merchantId,
        // initialValues: {
        //     ...initialData,
        // },
    };
};

interface FormData {
    password: string;
    confirm: string;
}

interface Props extends InjectedFormProps<FormData>, RouteComponentProps<{ id: string, merchantId: string }> {
    id: string;
    merchantId: string;
}

type S = {
    status: 'none' | 'loading' | 'notFound'
} | {
    status: 'loaded';
};

class ResetPasswordForm extends React.Component<Props, S> {

    // docRef: DocumentReference;
    // subscription: Subscription;

    // constructor(props: Props) {
    //     super(props);

    //     const { id } = props;

    //     this.docRef = firebase.firestore()
    //         .doc(`merchants/${this.props.merchantId}`)
    //         .collection('users')
    //         .doc(id);

    //     this.subscription = new Subscription();
    //     this.state = { status: 'loading' };
    // }

    // componentDidMount() {
    //     // this.setState({ status: 'loading' });
    //     const sn$ = new Observable<DocumentSnapshot>(observer => {
    //         return this.docRef.onSnapshot(sn => observer.next(sn));
    //     });

    //     const { initialize } = this.props;

    //     this.subscription = sn$.subscribe(sn => {
    //         if (sn.exists) {
    //             const { uid } = sn.data() as User;

    //             // const status = disabled ? 'disabled' : 'enabled';
    //             // const isAdminUser = uid === `admin@${merchantId}.piti.app` ? true : false;

    //             initialize({
    //                 uid
    //             });
    //             this.setState({ status: 'loaded' });
    //         }
    //     });
    // }

    // componentWillUnmount() {
    //     this.subscription.unsubscribe();
    // }

    submit = async ({ password }: FormData, dispatch: Dispatch<AppState>) => {

        try {
            const { id, merchantId } = this.props;
            const auth = firebase.functions().httpsCallable('resetMerchantUserPassword');
            const result = await Observable
                .defer(() => auth({ id, merchantId, newPassword: password }))
                .retry(5)
                .toPromise();

            const authResult = result.data as AuthResult;
            if (authResult.success) {
                dispatch(toast.success('your password is reset.'));
                dispatch(push(`/merchants/view/${merchantId}`));
            } else {
                dispatch(toast.success('Reset password failed.'));
            }
        }
        catch (err) {
            throw new SubmissionError({ code: err });
        }
    }

    render() {

        const { handleSubmit, submitting } = this.props;

        return (
            <Card title="Reset Password" bordered={true} bodyStyle={{ padding: 0 }} >
                <form className="code-box">
                    <section className="last">

                        <Field
                            name="password"
                            label="New Password"
                            {...formItemLayout}
                            type="password"
                            prefix={<Icon type="lock" />}
                            autoComplete="current-password"
                            component={TextField}
                            placeholder="Please input your password!"
                            validate={[required, passwordsMatch]}
                        />

                        <Field
                            name="confirm"
                            label="Confirm Password"
                            {...formItemLayout}
                            type="password"
                            prefix={<Icon type="lock" />}
                            autoComplete="current-password"
                            component={TextField}
                            placeholder="Please input your password!"
                            validate={[required, passwordsMatch]}
                        />

                    </section>
                    <section className="action-panel">
                        <Button type="primary" htmlType="submit" icon="save" loading={submitting} onClick={handleSubmit(this.submit)}>Save</Button>
                    </section>
                </form>
            </Card>
        );
    }
}

const rResetPasswordForm = reduxForm<Props>({
    form: 'resetPasswordForm',
    keepDirtyOnReinitialize: true,
    enableReinitialize: true,
    // tslint:disable-next-line:no-any
})(ResetPasswordForm as any) as any;

// const submitHandler = (appState: AppState, props: Props) =>
//     (values: ResetPasswordFormData) => {

//         const { onSubmit } = props;
//         onSubmit({
//             ...values,
//         });
//     };

// const getInitialFormData = (appState: AppState, props: DecoratedProps) => {
//     const { user } = props;
//     // do something
//     return {
//         ...user,
//     };
// };

export default connect(mapStateToProps)(rResetPasswordForm) as React.ComponentClass<Props>;



// WEBPACK FOOTER //
// ./src/merchants/forms/ResetPassword.tsx